import {
  any, boolean, date, dateDay,
  nullable, number, object, string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PublicBeaconMask = {
  actId: string | nullable,
  collaborators: any,
  compiledAddress: string,
  createdAt: date,
  endDate: dateDay | nullable,
  fuzzyLatLng: any,
  hasBeaconNotifications: boolean,
  hasConfirmation: boolean | nullable,
  hasMatch: boolean | nullable,
  hasRequest: boolean | nullable,
  hasShow: boolean | nullable,
  latLng: any,
  links: any,
  matchId: string | nullable,
  owner: string,
  processedAt: date | nullable,
  publicAct: object | nullable,
  radius: number,
  showId: string | nullable,
  startDate: dateDay,
  updatedAt: date,

  // New fields for show calls
  beaconStatus: string,
  city: string,
  country: string,
  description: string,
  isCancelled: boolean,
  isFeatured: boolean,
  isPublicCall: boolean,
  isShowCall: boolean,
  numResponses: number,
  numShares: number,
  numViews: number,
  profileId: string,
  profileData: object,
  profileType: string,
  region: string | nullable,
};
